import { Injectable, inject, signal } from '@angular/core';
import { Router } from '@angular/router';

const MOBILE_BREAKPOINT = 780;

@Injectable({ providedIn: 'root' })
export class UiService {
  private readonly router = inject(Router);
  spinnerVisible = signal(false);
  userSidebarMenuDialogVisible = signal(false);
  isMobile = signal(window.innerWidth <= MOBILE_BREAKPOINT);

  updateMobileState(): void {
    this.isMobile.set(window.innerWidth <= MOBILE_BREAKPOINT);
  }

  activeSurveysDialogVisible = signal(false);
  activeQuizzesDialogVisible = signal(false);

  previewStoryDialogVisible = signal(false);
  previewStoryId = signal<number | null>(null);

  previewUserDialogVisible = signal(false);
  previewUserId = signal<string | null>(null);

  toggleSpinner(isVisible: boolean) {
    this.spinnerVisible.set(isVisible);
  }

  toggleUserSidebarMenuDialogVisible(isVisible: boolean) {
    this.userSidebarMenuDialogVisible.set(isVisible);
  }

  toggleActiveQuizzesDialogVisible(isVisible: boolean) {
    this.activeQuizzesDialogVisible.set(isVisible);
  }

  toggleActiveSurveysDialogVisible(isVisible: boolean) {
    this.activeSurveysDialogVisible.set(isVisible);
  }

  togglePreviewStoryDialog(isVisible: boolean, storyId?: number) {
    this.router.navigate([], {
      queryParams: { previewStoryId: isVisible ? (storyId ?? null) : null },
      queryParamsHandling: 'merge',
    });
  }

  togglePreviewUserDialog(isVisible: boolean, userId?: string) {
    this.previewUserId.set(userId ?? null);
    this.previewUserDialogVisible.set(isVisible);
  }
}
